module.exports = __webpack_public_path__ + "img/estimatePicUploadTips.3580c5c3.jpg";